<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data, lightboxId }: ContentBlockComponentProps<ContentType.ImageBanner> = $props();
</script>

<div class="w-full full-width relative grid [grid-template-areas:'stack']">
	<div class="[grid-area:stack]">
		<Media
			alt=""
			class="object-cover mx-auto"
			height={242}
			width={2400}
			source={data.image}
			lightbox={lightboxId ?? true}
			sourcesets={{
				"<2xl": [242, 0],
				">2xl": [242, 0],
			}}
		/>
	</div>

	{#if data.text}
		<div class="absolute inset-0 bg-black/50"></div>
		<div
			class="[grid-area:stack] z-[1] flex size-full py-[0.125em] items-center justify-center font-druk-cond text-white text-center text-xl xs:text-3xl sm:text-5xl md:text-6xl xl:text-9xl/[1.1]"
		>
			<Formatted text={data.text} />
		</div>
	{:else}
		<div class="[grid-area:stack]"></div>
	{/if}
</div>
